var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-generator',{attrs:{"fields":_vm.fields,"resource":_vm.resource || _vm.$options.passwordRecoveryResource,"form":_vm.form,"custom-validatator-parser":_vm.errorsParser,"data-formatter":_vm.formatter,"btn-text":_vm._("Сохранить")}})}
var staticRenderFns = []

export { render, staticRenderFns }